<!-- Outlet Selection -->
<ng-container *ngIf="isMultiSelect">
  <mat-form-field appearance="outline">
    <mat-select
      [placeholder]="'CHOOSE_OUTLET' | fallbackTranslate"
      disableOptionCentering
      panelClass="dropDownClass"
      name="Select"
      [(ngModel)]="selectedOutlet"
      (ngModelChange)="onOutletChange($event)"
      multiple
      #selectionModel="ngModel"
    >
      <mat-select-trigger>
        <ng-container *ngIf="selectedOutlet?.length === outletList.length">
          {{ 'ALL_OUTLETS' | fallbackTranslate }}
          <!-- GLOBAL -->
        </ng-container>
        <ng-container *ngIf="selectedOutlet?.length !== outletList.length">
          {{
            selectedOutlet.length
              ? (returnRestName(selectedOutlet[0]) | titlecase)
              : ''
          }}
          <span
            *ngIf="selectedOutlet?.length > 1"
            class="example-additional-selection"
          >
            (+{{ selectedOutlet.length - 1 }}
            {{ selectedOutlet?.length === 2 ? 'other' : 'others' }})
          </span>
        </ng-container>
      </mat-select-trigger>
      <app-select-check-all
        [model]="selectionModel"
        [values]="outletList"
        [settlement]="isSettlement"
      >
      </app-select-check-all>
      <ng-container *ngFor="let option of outletList">
        <ng-container *ngIf="(isPricingFilter && option?.settings?.global?.plan !== membershipOutlet?.LITE) || !isPricingFilter">
          <mat-option [value]="option?.id" [disabled]="isSettlement ? !option?.settings?.settlement?.visible : !true">
            {{ option?.name }}
          </mat-option>
        </ng-container>
      </ng-container>      
    </mat-select>
  </mat-form-field>
</ng-container>

<ng-container *ngIf="!isMultiSelect">
  <nz-select nzDropdownMatchSelectWidth="false" nzName="Select" [(ngModel)]="selectedOutlet"
    (ngModelChange)="onOutletChange($event)" nzSize="large" [nzPlaceHolder]="'CHOOSE_OUTLET' | fallbackTranslate">
    <ng-container *ngFor="let option of outletList">
      <ng-container *ngIf="(isPricingFilter && option?.settings?.global?.plan !== membershipOutlet?.LITE) || !isPricingFilter">
        <nz-option [nzValue]="option.id" [nzLabel]="option.name">
        </nz-option>
      </ng-container>
    </ng-container>
  </nz-select>

</ng-container>
